import { useEffect, useState } from "react";

/** 输入防抖：关键词筛选必须防抖，否则每个字符都触发 10,000 行的 filter + 重渲染（INP 杀手）。 */
export function useDebouncedValue<T>(value: T, delayMs = 200): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
